import mapperIcon from '#layers/core/data-layer/utils/mappers/mapper-icon'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page Privacy Policy Detail mapper
 * normalizes data to be used in pages
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    contentLocale: data.locale || '',
    introText: data.introText || null,
    icon: mapperIcon(data.icon),
    highlightText: data.highlightText || null,
    defaultLocaleFallbackEnabled: data.defaultLocaleFallbackEnabled || false,
    // null check of subchapters done in the chapter.vue component
    chapters: data.chaptersCollection?.items?.filter(Boolean) || [],
    navigationItems:
      data?.parent?.itemsCollection?.items.filter(Boolean).map((item: any) => ({
        title: item.navigationTitle,
        url: options.getInternalUrl(item.sys.id)
      })) || []
  }
}
